export const stagesText = {
  en: {
    sectionTitle: "PROCESS",
    intro:
      "We work closely with you at every step, with personalized attention to your preferences, so nothing about scope, progress or delivery catches you by surprise.",
    stages: [
      {
        step: 1,
        title: "Discovery & Planning",
        description:
          "We analyze your business needs and objectives, working closely with stakeholders to define scope, gather requirements, and set clear goals and timelines.",
      },
      {
        step: 2,
        title: "Design & Architecture",
        description:
          "Our design phase shapes intuitive user experiences and robust architecture through wireframes, prototypes and the technical specs behind your solution.",
      },
      {
        step: 3,
        title: "Development",
        description:
          "Using agile methodologies, we build your solution with clean, maintainable code, delivering working components in iterative cycles and folding in feedback.",
      },
      {
        step: 4,
        title: "Testing & QA",
        description:
          "We run automated, performance and user acceptance testing throughout, so your software meets high standards of reliability before it reaches your users.",
      },
      {
        step: 5,
        title: "Deployment",
        description:
          "We handle deployment to production end to end: configuration, security measures and monitoring, so your solution runs stably from its first day live.",
      },
      {
        step: 6,
        title: "Maintenance & Support",
        description:
          "After launch we stay on with regular updates, performance optimization and responsive technical support to keep your software running smoothly as it grows.",
      },
    ],
    cta: {
      title: "Start a project?",
      link: "Contact Us",
    },
  },
  es: {
    sectionTitle: "PROCESO",
    intro:
      "Trabajamos cerca de ti en cada etapa, con atención personalizada a tus preferencias, para que nada del alcance, el avance o la entrega te tome por sorpresa.",
    stages: [
      {
        step: 1,
        title: "Descubrimiento y Planificación",
        description:
          "Analizamos tus necesidades y objetivos junto a los stakeholders para definir el alcance, recopilar requisitos y fijar metas y cronogramas claros.",
      },
      {
        step: 2,
        title: "Diseño y Arquitectura",
        description:
          "La fase de diseño define experiencias intuitivas y una arquitectura robusta, con wireframes, prototipos y las especificaciones técnicas de tu solución.",
      },
      {
        step: 3,
        title: "Desarrollo",
        description:
          "Con metodologías ágiles construimos tu solución con código limpio y mantenible, entregando componentes funcionales por ciclos e incorporando feedback.",
      },
      {
        step: 4,
        title: "Pruebas y Control de Calidad",
        description:
          "Aplicamos pruebas automatizadas, de rendimiento y de aceptación para que tu software cumpla altos estándares de confiabilidad antes de llegar a producción.",
      },
      {
        step: 5,
        title: "Despliegue",
        description:
          "Nos encargamos del despliegue a producción de punta a punta: configuración, seguridad y monitoreo, para que todo funcione estable desde el primer día.",
      },
      {
        step: 6,
        title: "Mantenimiento y Soporte",
        description:
          "Después del lanzamiento seguimos con actualizaciones, optimización de rendimiento y soporte técnico para que tu software funcione sin problemas.",
      },
    ],
    cta: {
      title: "¿Iniciamos tu proyecto?",
      link: "Contáctanos",
    },
  },
  ja: {
    sectionTitle: "プロセス",
    intro:
      "すべての工程であなたと密に連携し、ご希望に合わせた対応を行うことで、範囲・進捗・納品のいずれにも想定外が起きないようにします。",
    stages: [
      {
        step: 1,
        title: "発見と計画",
        description:
          "ビジネスのニーズと目標を分析し、関係者と連携して範囲を定義し、要件を整理して明確な目標とスケジュールを設定します。",
      },
      {
        step: 2,
        title: "設計とアーキテクチャ",
        description:
          "直感的な体験と堅牢なアーキテクチャを設計し、ワイヤーフレーム、プロトタイプ、技術仕様として形にします。",
      },
      {
        step: 3,
        title: "開発",
        description:
          "アジャイル手法で保守しやすいコードを書き、反復的なサイクルで機能を提供しながらフィードバックを反映します。",
      },
      {
        step: 4,
        title: "テストと品質保証",
        description:
          "自動テスト、性能テスト、受け入れテストを通じて、リリース前に高い信頼性と性能を確認します。",
      },
      {
        step: 5,
        title: "展開",
        description:
          "本番環境への展開を一貫して担当し、構成・セキュリティ・監視を整えて初日から安定して動く状態にします。",
      },
      {
        step: 6,
        title: "保守とサポート",
        description:
          "リリース後も定期的な更新、性能改善、迅速な技術サポートで、円滑な運用を継続的に支えます。",
      },
    ],
    cta: {
      title: "プロジェクトを始めましょうか？",
      link: "お問い合わせ",
    },
  },
};
